import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

import { DashboardService } from '../shared/dashboard.service';
import { RetentionRow } from '../shared/retention-row.model';

@Component({
  selector: 'wl-dashboard-retention',
  templateUrl: 'retention.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [DashboardService],
  styleUrls: ['retention.component.less'],
    standalone: false
})
export class DashboardRetentionComponent implements OnInit {
  public retentionDetails: Array<RetentionRow>;
  public retentionTotals: RetentionRow;
  public showRetentionDetails: boolean;
  public startDate: Date;
  public endDate: Date;
  public isLoading: boolean;

  private _dashboardService: DashboardService;

  public constructor(dashboardService: DashboardService) {
    this._dashboardService = dashboardService;
    this.isLoading = true;
  }

  ngOnInit() {
    this.retentionDetails = new Array<RetentionRow>();
    this.retentionTotals = new RetentionRow();
    this.showRetentionDetails = false;

    this.getRetentionReport();
  }

  public getRetentionReport() {
    this._dashboardService.getRetentionReport(this.startDate, this.endDate).then((data: Array<RetentionRow>) => {
      this.retentionDetails = data;

      this.calculateRetentionTotals();
      this.isLoading = false;
    });
  }

  public toggleRetentionDetails() {
    this.showRetentionDetails = !this.showRetentionDetails;
  }

  private calculateRetentionTotals(): void {
    this.retentionTotals = new RetentionRow();

    let accountsBilled: number = this.retentionDetails.reduce((accountsBilled, current) => accountsBilled + current.AccountsBilled, 0);
    this.retentionTotals.AccountsBilled = accountsBilled;

    let accountsPaid: number = this.retentionDetails.reduce((accountsPaid, current) => accountsPaid + current.AccountsPaid, 0);
    this.retentionTotals.AccountsPaid = accountsPaid;

    let amountBilled: number = this.retentionDetails.reduce((amountBilled, current) => amountBilled + current.AmountBilled, 0);
    this.retentionTotals.AmountBilled = amountBilled;

    let amountPaid: number = this.retentionDetails.reduce((amountPaid, current) => amountPaid + current.AmountPaid, 0);
    this.retentionTotals.AmountPaid = amountPaid;

    //calculate retention percentages differently
    this.retentionTotals.MemberRetention = this.retentionTotals.AccountsPaid / this.retentionTotals.AccountsBilled;
    this.retentionTotals.InvestmentRetention = this.retentionTotals.AmountPaid / this.retentionTotals.AmountBilled;
  }
}
